export const INITIAL_VALUES = { email_news_letter: '' };

export const FETCH_OPTIONS = {
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		Accept: 'application/json',
		Authorization: `Bearer ${process.env.REACT_APP_FRESH_MAIL_TOKEN}`
	}
};
